<template>
  <HeroView/>
  <ThemesView/>
  <BenefitsView/>
  <FaqView/>
  <FinalView/>
</template>

<script>
import HeroView from '@/components/home/HeroView.vue'
import ThemesView from '@/components/home/ThemesView.vue'
import BenefitsView from '@/components/home/BenefitsView.vue'
import FaqView from '@/components/home/FaqView.vue'
import FinalView from '@/components/home/FinalView.vue'

export default {
  name: 'HomeView',
  components: {
    HeroView,
    ThemesView,
    BenefitsView,
    FaqView,
    FinalView
  }
}
</script>
